import { render, staticRenderFns } from "./PriTama04_Nico.vue?vue&type=template&id=af46d5f6&scoped=true&"
import script from "./PriTama04_Nico.vue?vue&type=script&lang=js&"
export * from "./PriTama04_Nico.vue?vue&type=script&lang=js&"
import style0 from "./PriTama04_Nico.vue?vue&type=style&index=0&id=af46d5f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af46d5f6",
  null
  
)

export default component.exports